import Qs from 'qs'

import { createAuthedHttpClient, redirectToLoginPage } from '@driftt/web-auth'

import config from 'config'

const redirectToLoginOnAuthError = (error) => {
  if (
    error.response?.status === 401 ||
    (error.response?.status === 403 &&
      error.response?.data?.key === 'InvalidUser')
  ) {
    redirectToLoginPage(config.AUTH_CLIENT_ID)
  }
}

export const AccountsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNTS_API,
  },
})

export const AccountActivityApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNT_ACTIVITY_API,
  },
})

export const AIPlatformAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.AI_PLATFORM_API,
  },
})

export const AllAboardAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ALL_ABOARD_API,
  },
})

export const BillingAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.BILLING_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const BillingAPIBlobResponse = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.BILLING_API,
    responseType: 'blob',
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const BootstrapApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.BOOTSTRAP_API,
  },
})

export const MicrosoftAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MICROSOFT_TEAMS_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const WidgetCacheApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.WIDGET_CACHE_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const ContentManagementAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONTENT_MANAGEMENT_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const AuthAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.AUTH_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const RoutingAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ROUTING_API,
  },
})

export const InsightsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INSIGHTS_API,
  },
})

export const IntegrationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INTEGRATION_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const IntegrationSyncSchdulerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INTEGRATION_SYNC_SCHEDULER_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const SlackIntegrationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.SLACK_INTEGRATION_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const SalesloftIntegrationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.SALESLOFT_INTEGRATION_API,
  },
})

export const FalcorAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FALCOR_API,
  },
})

export const FileAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FILE_API,
    raw: true,
  },
})

export const MeetingsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MEETINGS_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const DriftAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.DRIFT_API,
  },
})

export const EmailAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.EMAIL_API,
  },
})

export const GdprAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.GDPR_API,
  },
})

export const WorkspacesAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.WORKSPACE_API,
  },
})

export const InboxAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INBOX_API,
  },
})

export const MessagingApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MESSAGING_API,
  },
})

export const ReachAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.REACH_API,
  },
})

export const SyncjobAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.SYNCJOB_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const PlanFeaturesAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.PLAN_FEATURES_API,
  },
})

export const PlaybookReusabilityAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.PLAYBOOK_REUSABILITY_API,
  },
})

export const RolesProxyAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ROLES_PROXY_API,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError],
})

export const TicketAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.TICKET_API,
  },
})

export const NotificationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.NOTIFICATIONS_API,
  },
})

export const UserActivityAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.USER_ACTIVITY_API,
  },
})
